const NGUONG_GAN_DAY = 0.9;

// Chu trình đủ của 1 Sọt: dang_thu_mua/gan_day (đang thu mua ngoài vườn)
// -> da_dong (đầy, tự khoá, không cho thu mua thêm) -> da_nhap_kho (nhân
// viên kho cân lại khi nhận vào kho, xem sotApi.nhapKho) -> xuất kho (bán
// đi) -> reset về moi_tao để tái sử dụng (xem sotApi.xuatKho). Cả 2 trạng
// thái này đều "khoá" theo nghĩa không cho thu mua thêm vào Sọt.
export const TRANG_THAI_KHOA = ["da_dong", "da_nhap_kho"];

export function tinhTrangThaiTiepTheo(khoiLuongHienTai, khoiLuongToiDa, trangThaiHienTai) {
  // Đã nhập kho thì chỉ xuất kho (sotApi.xuatKho) mới reset — không mở lại
  // khi sửa/xoá phiếu. da_dong thì KHÁC: đầy rồi xoá/sửa phiếu phải tính
  // lại từ kg, không thì Sọt 0 kg vẫn "đã đóng" không thu mua/nhập được.
  if (trangThaiHienTai === "da_nhap_kho") return trangThaiHienTai;
  if (!khoiLuongHienTai || khoiLuongHienTai <= 0) return "moi_tao";
  const toiDa = Number(khoiLuongToiDa);
  if (!Number.isFinite(toiDa) || toiDa <= 0) return "dang_thu_mua";
  if (khoiLuongHienTai >= toiDa) return "da_dong";
  if (khoiLuongHienTai >= toiDa * NGUONG_GAN_DAY) return "gan_day";
  return "dang_thu_mua";
}
